import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const sentryDsn =
  typeof __SENTRY_DSN_PUBLIC__ !== 'undefined' ? __SENTRY_DSN_PUBLIC__ : '';

const isProduction = import.meta.env.PROD;

export function initSentry(): void {
  if (!sentryDsn) return;

  Sentry.init({
    dsn: sentryDsn,
    enabled: true,
    environment: import.meta.env.MODE,
    tracesSampleRate: isProduction ? 0.1 : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: isProduction ? 1.0 : 0,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
      }),
    ],
    beforeSend(event) {
      if (!isProduction && window.location.hostname === 'localhost') return null;
      return event;
    },
  });
}

/** Clears Sentry user context after server logout (shared browser safety). */
export function resetSentryAfterLogout(): void {
  if (!sentryDsn) return;
  try {
    Sentry.setUser(null);
    Sentry.setTag('instance_id', '');
  } catch {
    /* Sentry not configured or not yet loaded */
  }
}

export { Sentry };
